// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100%\" height=\"100%\" viewBox=\"0 0 13 13\"> <path d=\"m 3.5635,6.5038 1.958,1.958 3.915,-3.916\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"/> </svg> ";
// Exports
module.exports = code;